import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { IteratorField } from '../../types/fields.type';

@Component({
  selector: 'hospitality-bot-iterator',
  templateUrl: './iterator.component.html',
  styleUrls: ['./iterator.component.scss'],
})
export class IteratorComponent implements OnChanges {
  constructor(protected fb: FormBuilder) {}

  @Output() currentIndex: EventEmitter<number> = new EventEmitter<number>();
  @Output() removedIndex: EventEmitter<number> = new EventEmitter<number>();

  @Input() fields: IteratorField[];
  @Input() useFormArray: FormArray;
  @Input() ctaLabel: '+ Add More';
  @Input() itemValues = [];

  @ViewChild('main', { static: true }) main: ElementRef;

  // Zero maxLimit means there is no limit
  @Input() maxLimit = 0;

  ngOnChanges(changes: SimpleChanges): void {
    const itemValues = changes?.itemValues?.currentValue;
    if (itemValues?.length) {
      if (itemValues.length > 1) {
        // Create new form fields for each item in the array
        itemValues.slice(1).forEach((item) => {
          this.createNewFields();
        });
      }
      // Patch the new values to the form array
      this.useFormArray.patchValue(itemValues);
    }
  }

  ngOnInit() {
    if(!this.useFormArray.length)
    this.createNewFields();
  }

  /**
   * @function createNewFields To get the initial value config
   */
  createNewFields() {
    const data = this.fields.reduce((prev, curr) => {
      let value;
      if (curr.minValue) {
        value = [
          '',
          [
            Validators.required,
            Validators.min(curr?.minValue),
            ...(curr?.validators || []),
          ],
        ];
      } else {
        value = curr.required
          ? ['', [Validators.required, ...(curr?.validators || [])]]
          : ['', [...(curr?.validators || [])]];
      }
      prev[curr.name] = value;
      return prev;
    }, {});

    const formGroup = this.fb.group(data);
    this.useFormArray.push(formGroup);
    const index = this.useFormArray.controls.indexOf(formGroup);
    this.currentIndex.emit(index);
  }

  get width() {
    const currentWidth = 100 / this.fields.length;
    return `${currentWidth > 20 ? 20 : currentWidth}%`;
  }

  /**
   * Handle addition of new field to array
   */
  addNewField() {
    if (this.useFormArray.invalid) {
      this.useFormArray.markAllAsTouched();
      return;
    }
    this.createNewFields();

    // scroll to bottom of the iterator
    setTimeout(() => {
      const mainEl = this.main.nativeElement;
      mainEl.scrollTop = mainEl.scrollHeight;
    });
  }

  /**
   * @function removeField handle the removal of fields from array
   * @param index position at which value is to be removed
   */
  removeField(index: number) {
    if (this.useFormArray.length === 1) {
      if (this.useFormArray.valid) this.useFormArray.at(0).reset();
      return;
    }
    this.useFormArray.removeAt(index);
    this.removedIndex.emit(index);
  }
}
